import React from 'react';
import CustomImagesInput from '../../../../components/imageInput/CustomImageInput';
import ImageUploader from 'react-images-upload';
import { Grid, Paper, Box, Typography, Input, Button } from '@mui/material';
import { useTranslate } from 'react-admin';
import { FileCopySharp } from '@mui/icons-material';

type IProps = {
  attachments: string[];
  onChange: (f: any | null) => void;
  onRemove: (f: any | null) => void;
};
function AttachmentsInput({ attachments, onChange, onRemove }: IProps) {
  const t = useTranslate();
  return (
    <Paper
      sx={{
        padding: 2,
      }}
    >
      <Typography
        sx={{
          marginTop: 1,
          marginBottom: 1,
        }}
      >
        {t('attachments')}
      </Typography>
      <Grid container>
        {attachments.map((im) => (
          <Grid key={im} item lg={3} md={4} sm={6}>
            <Box
              sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <FileCopySharp fontSize='large' />
              <a
                style={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}
                href={im}
              >
                <Typography width={'100%'} textAlign='center' variant='caption'>
                  {im?.substring(im.lastIndexOf('/') + 1)}
                </Typography>
              </a>
              <Button color='error' onClick={() => onRemove(im)}>
                {t('remove')}
              </Button>
            </Box>
          </Grid>
        ))}

        <Grid item lg={3} md={4} sm={6}>
          <Box>
            <input
              type='file'
              accept='*'
              multiple
              onChange={(e) => onChange(e?.target?.files)}
            />
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default AttachmentsInput;
